import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const LineChart = ({
  data,
  title,
  height = 300,
  showLegend = true,
  showGrid = true,
  tension = 0.4,
  fill = false,
  borderColor = "#7352FF",
  backgroundColor = "rgba(115, 82, 255, 0.1)",
  pointBackgroundColor = "#7352FF",
  pointBorderColor = "#ffffff",
  pointBorderWidth = 2,
  pointRadius = 4,
  pointHoverRadius = 6,
}) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: showLegend,
        position: "top",
        labels: {
          usePointStyle: true,
          padding: 20,
          font: {
            size: 12,
          },
          color: "#ffffff",
        },
      },
      title: {
        display: !!title,
        text: title,
        font: {
          size: 16,
          weight: "bold",
        },
        padding: {
          top: 10,
          bottom: 20,
        },
        color: "#ffffff",
      },
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "rgba(0, 0, 0, 0.9)",
        titleColor: "#ffffff",
        bodyColor: "#ffffff",
        borderColor: "#7352FF",
        borderWidth: 1,
        cornerRadius: 8,
        displayColors: true,
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat("en-NG", {
                style: "currency",
                currency: "NGN",
              }).format(context.parsed.y);
            }
            return label;
          },
        },
      },
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: showGrid,
          color: "rgba(255, 255, 255, 0.1)",
        },
        ticks: {
          font: {
            size: 11,
          },
          maxRotation: 45,
          color: "#ffffff",
        },
      },
      y: {
        display: true,
        grid: {
          display: showGrid,
          color: "rgba(255, 255, 255, 0.1)",
        },
        ticks: {
          font: {
            size: 11,
          },
          color: "#ffffff",
          callback: function (value) {
            if (value >= 1000000) {
              return "₦" + (value / 1000000).toFixed(1) + "M";
            } else if (value >= 1000) {
              return "₦" + (value / 1000).toFixed(1) + "K";
            }
            return "₦" + value.toLocaleString();
          },
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    elements: {
      point: {
        backgroundColor: pointBackgroundColor,
        borderColor: pointBorderColor,
        borderWidth: pointBorderWidth,
        radius: pointRadius,
        hoverRadius: pointHoverRadius,
      },
    },
  };

  const chartData = {
    ...data,
    datasets: data.datasets.map((dataset) => ({
      ...dataset,
      borderColor: dataset.borderColor || borderColor,
      backgroundColor: dataset.backgroundColor || backgroundColor,
      tension: dataset.tension || tension,
      fill: dataset.fill || fill,
      pointBackgroundColor: dataset.pointBackgroundColor || pointBackgroundColor,
      pointBorderColor: dataset.pointBorderColor || pointBorderColor,
      pointBorderWidth: dataset.pointBorderWidth || pointBorderWidth,
      pointRadius: dataset.pointRadius || pointRadius,
      pointHoverRadius: dataset.pointHoverRadius || pointHoverRadius,
    })),
  };

  return (
    <div style={{ height: height }}>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default LineChart; 